export default "__VITE_PUBLIC_ASSET__0d452aa9__"